import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BvDialogService, BvToastService } from "../../design-system";
import {
  BvDialogTitleComponent,
  BvDialogBodyComponent,
  BvDialogFooterComponent,
} from "../../design-system/primitives/dialog.component";
import { BvFormFieldComponent } from "../../design-system/primitives/form-field.component";
import { BvInputDirective } from "../../design-system/primitives/input.directive";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { LoadingOverlayComponent } from "../../shared/loading-overlay/loading-overlay.component";
import { CloseDialogButtonComponent } from "../../shared/close-dialog-button/close-dialog-button.component";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { ProfileService } from "src/app/providers/profile.service";

@Component({
  selector: "app-delete-account",
  templateUrl: "./delete-account.component.html",
  styleUrls: ["./delete-account.component.scss"],
  imports: [
    FormsModule,
    TranslateModule,
    BvDialogTitleComponent,
    BvDialogBodyComponent,
    BvDialogFooterComponent,
    BvFormFieldComponent,
    BvInputDirective,
    BvButtonComponent,
    LoadingOverlayComponent,
    CloseDialogButtonComponent,
  ],
})
export class DeleteAccountComponent implements OnInit {
  // The word the user must type to enable deletion (localized).
  confirmWord = "";
  confirmInput = "";
  ownedClubsCount = 0;
  hasSubscription = false;
  deleting = false;

  constructor(
    public profServ: ProfileService,
    private api: ApiService,
    private auth: AuthService,
    private dialog: BvDialogService,
    private toast: BvToastService,
    private translate: TranslateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.confirmWord = this.translate.instant("DELETE_CONFIRM_WORD");
    const clubs = this.profServ.latestProfile?.clubs || {};
    this.ownedClubsCount = Object.values(clubs).filter(
      (club: any) => club.role === "Owner"
    ).length;
    this.hasSubscription = !!this.profServ.latestSubscription?.id;
  }

  get canDelete(): boolean {
    return (
      !this.deleting &&
      this.confirmInput.trim().toUpperCase() === this.confirmWord.toUpperCase()
    );
  }

  confirmDelete(): void {
    if (!this.canDelete) return;
    this.deleting = true;
    this.api
      .deleteOwnProfile()
      .then(() => {
        this.dialog.closeAll();
        this.auth.logout();
        this.router.navigate(["/login"]);
        this.toast.open(this.translate.instant("ACCOUNT_DELETED"), this.translate.instant("OK"), {
          duration: 5000,
        });
      })
      .catch((error: any) => {
        console.error(error);
        this.deleting = false;
        this.toast.open(this.translate.instant("GENERIC_ERROR"), this.translate.instant("OK"), {
          duration: 5000,
        });
      });
  }
}
